import { homeStyle } from "./home";
import { projectStyle } from "./projects";
import { skillStyle } from "./skills";
import { adobeStyle } from "./adobe";
import { blogStyle } from "./blog";

//Aggregate Styling

export const webStyle = {
    homeStyle,
    projectStyle,
    skillStyle,
    adobeStyle,
    blogStyle,
};